<template>
  <div class="mt-20 flex flex-col items-center">
    <div class="mb-3">
      {{
        $t('pagination.pagination_text', {
          perPage: perPage,
          total: totalCount,
        })
      }}
    </div>
    <div v-if="currentPage && totalCount">
      <slot>
        <SFButton
          v-if="isNextPageAvailable"
          :to="nextPage"
          @click.prevent="loadMore"
        >
          {{ $t('pagination.load_more') }}
        </SFButton>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from '#app/composables/router'
import { SFButton } from '#storefront-ui/components'
import { useHead } from '#imports'

// Destructure the props into local variables
const { totalCount, count, pageToLoad } = defineProps<{
  totalCount?: number
  count?: number
  pageToLoad?: number | null
}>()

const route = useRoute()
const router = useRouter()

const currentPage = computed(() => Number(route.query.page || 1))

const isNextPageAvailable = computed(() => Boolean(pageToLoad))

const perPage = computed(() => count ?? totalCount)

const nextPage = computed(() => ({
  query: {
    ...route.query,
    page: pageToLoad ?? currentPage.value + 1,
  },
}))

const loadMore = async () => {
  if (!pageToLoad) {
    return
  }
  await router.push(nextPage.value)
}

if (currentPage.value >= 2) {
  useHead({
    meta: [{ name: 'robots', content: 'noindex, follow' }],
  })
}
</script>
